// React component
import { ReactNode } from "react";

// Formik props & components
import { FormikProps } from "formik";

// Types
import { IDictionary, IGenericObject } from "../commonTypes/commonTypes";

// Common search select props
export interface ISearchSelectProps {
  list: IDictionary | IGenericObject[] | null;
  formik: FormikProps<any>;
  label?: ReactNode;
  currentValue: string | number | IGenericObject;
  formPath: string;
  width?: string;
  type?: string;
  sx?: { [kay: string]: any };
  disabled?: boolean;
  isObjectDataRequired?: boolean;
  /** When true, the text box is read-only: the user can open the dropdown
   *  and pick an option but cannot type free text to filter. Useful for
   *  strict "select from list only" fields (e.g. Field → Branch). Defaults
   *  to false so existing usages keep their type-to-filter behaviour. */
  readOnlyInput?: boolean;
  /** When true, the dropdown popup shows a "Loading…" indicator instead
   *  of the empty-state "No options" text. Use while the parent is still
   *  fetching the lookup that backs ``list`` — this prevents the
   *  misleading flash of "No options" before the data arrives. */
  loading?: boolean;
  /** AA-1733 — optional per-option text colour. Given an option's `id`,
   *  returns a CSS colour (or undefined for the default text colour). Used
   *  by the Field-tab EUDR filter dropdowns to match the Compliance Report
   *  colouring (`getEudrValueColor`). Optional so every other
   *  CommonSearchSelect usage keeps its default (uncoloured) behaviour. */
  getOptionColor?: (id: string) => string | undefined;
}

export enum TypeOfList {
  Directory = "Dictionary",
  ArrayOfObject = "ArrayOfObject",
}
